import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { doc, deleteDoc, addDoc, collection, where, query, getDocs } from 'firebase/firestore';
import { MdDelete, MdEdit } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useUserAuth } from '../../context/UserAuthContext';
import init from '../../firebase';

const InvoiceBasicInfo = () => {
    const { user } = useUserAuth();
    const merchant_id = user.uid;
    const [invoiceInfo, setInvoiceInfo] = useState([])
    const [status, setStatus] = useState(false)
    const getSingleDocumentHandler = async () => {
        const mycollection = collection(init.db, 'vendorInvoiceInfo');
        let q = query(mycollection, where('merchant_id', '==', merchant_id));
        const data = await getDocs(q);
        setInvoiceInfo(data?.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        if(invoiceInfo.length > 0){
            setStatus(true)
        }
    }
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, invoiceInfo, status])

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [data, setData] = useState({
        business_name: '',
        mobno: '',
        email: '',
        gst: '',
        bankName: '',
        accountNo: '',
        ifscNo: '',
        t_c: '',
        address:""
    })
    const formHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setData({ ...data, [name]: value })
    }
    const btnHandler = async () => {
        const { business_name, mobno, email, gst, bankName, accountNo, ifscNo, t_c, address } = data;
        if (business_name !== '' && mobno !== ""  && bankName !== "" && accountNo !== "" && ifscNo !== "" && address !== "") {
            try {
                const docRef = await addDoc(collection(init.db, "vendorInvoiceInfo"), {
                    merchant_id,
                    business_name, mobno, email, gst, bankName, accountNo, ifscNo, t_c, address
                })
                setData({
                    business_name: '',
                    mobno: '',
                    email: '',
                    gst: '',
                    bankName: '',
                    accountNo: '',
                    ifscNo: '',
                    t_c: '',
                    address: '',
                })
                toast.success('Invoice Basic Info Added Successfully');
                handleClose()
            } catch (err) {
                console.log(err);
            }
        }
        else {
            toast.error('please fill your all field');
        }
    }
    const deleteStaff = async (staffId) => {
        const choice = window.confirm('Are you sure want to delete?');
        if (choice) {
            try {
                const result = await deleteDoc(doc(init.db, "vendorInvoiceInfo", staffId));
                toast.success('Basic Info deleted Successfully');
                getSingleDocumentHandler()
            } catch (err) {
                console.log(err)
            }
        } else {
            return
        }
    }
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title> Add Invoice Basic Information</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <form className="form-horizontal">
                        <div className="card-body">
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Business Name <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data?.business_name}
                                    name='business_name'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Business Name"
                                />
                            </div>
                        
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Email (Optional)</label>

                                <input
                                    onChange={formHandler} value={data?.email}
                                    name='email'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Email"
                                />
                            </div>
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Address <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data?.address}
                                    name='address'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Address"
                                />
                            </div>
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Mobile number <span className='text-danger'>*</span></label>

                                <input
                                    onChange={formHandler} value={data?.mobno}
                                    name='mobno'
                                    type="tel"
                                    maxLength={12}
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Mobile Number"
                                />
                            </div>
                            
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >GST Number (Optional)</label>

                                <input
                                    onChange={formHandler} value={data?.gst}
                                    name='gst'
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter your Gst Number"
                                />
                            </div>
                            <div className="form-group">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Bank Name<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler} value={data?.bankName}
                                    type="text"
                                    className="form-control"
                                    name='bankName'
                                    placeholder="Enter your Bank Name"
                                    
                                />
                            </div>

                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Accout Number<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler}
                                    value={data?.accountNo}
                                    type="number"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter Account Number"
                                    name='accountNo'
                                />
                            </div>
                            
                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >IFSC Code<span className='text-danger'>*</span></label>
                                <input
                                    onChange={formHandler}
                                    value={data?.ifscNo}
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter IFSC code"
                                    name='ifscNo'
                                />
                            </div>
                            <div className="form-group ">
                                <label
                                    for="fname"
                                    className=" text-start control-label col-form-label"
                                >Terms & Conditions<span className='text-danger'>*</span></label>
                                <textarea
                                    onChange={formHandler}
                                    value={data?.t_c}
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    placeholder="Enter Terms & Conditions"
                                    name='t_c'
                                />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="" className='btn text-white ' style={{ backgroundColor: '#085f9a' }} onClick={btnHandler}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className='card-header  d-flex justify-content-between align-items-center'>
                                        <h4>Inovice Basic Information</h4>
                                        <button type="button" className="btn text-white" style={{ backgroundColor: '#085f9a' }}  onClick={handleShow} disabled={status ? true : false}>
                                            {`${status ? 'Update Inoice Detail' : 'Add Invoice Info'}`}
                                        </button>
                                </div>
                                <div className='card-body'>
                                    <div className='table-responsive'>
                                        <table className='table  table-bordered  shadow-sm mt-3' cellPadding={5}>
                                            <tr style={{ backgroundColor: '#f6fbff' }}>
                                                <th style={{ fontWeight: 'bold' }}>S.No.</th>
                                                <th style={{ fontWeight: 'bold' }}>Business Name</th>
                                                <th style={{ fontWeight: 'bold' }}>Email</th>
                                                <th style={{ fontWeight: 'bold' }}>Mobile Number</th>
                                                <th style={{ fontWeight: 'bold' }}>Address</th>
                                                <th style={{ fontWeight: 'bold' }}>Bank Name</th>
                                                <th style={{ fontWeight: 'bold' }}>Account Number</th>
                                                <th style={{ fontWeight: 'bold' }}>IFSC Code</th>
                                                <th style={{ fontWeight: 'bold' }}>GST Number</th>
                                                <th style={{ fontWeight: 'bold' }}>Terms & Con.</th>
                                                <th style={{ fontWeight: 'bold' }}>Edit</th>
                                                <th style={{ fontWeight: 'bold' }}>Delete</th>
                                            </tr>
                                            {
                                                invoiceInfo?.map((cur, index) => {
                                                    return (
                                                        <>
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{cur.business_name}</td>
                                                            <td>{cur.email}</td>
                                                            <td>{cur.mobno}</td>
                                                            <td>{cur.address}</td>
                                                            <td>{cur.bankName}</td>
                                                            <td>{cur.accountNo}</td>
                                                            <td>{cur.ifscNo}</td>
                                                            <td>{cur.gst}</td>
                                                            <td>{cur.t_c}</td>
                                                            <td><Link to={`/dashboard/edit-invoice/${cur.id}`} className='text-success'><MdEdit size={30} /></Link></td>
                                                            <td><button className='btn btn-sm text-danger' onClick={() => deleteStaff(cur.id)}><MdDelete size={30} /></button></td>
                                                        </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default InvoiceBasicInfo